// extracted by mini-css-extract-plugin
module.exports = {"cell":"BooleanCell_cell__NsFl0"};